import { CustomHandler } from "@crescentParts/Store/CustomHandlerCreator";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomHandler<{ahriData:any, ahriPagination: any}>

export const DispatchSelectedData: HandlerType = props =>{
    props.dispatch({
        type:"Custom/AHRISystemToolConfigData/fetchData",
        ahriData: props.parameter.ahriData,
        ahriPagination: props.parameter.ahriPagination
    })
}
export const chain = [DispatchSelectedData];

const AHRISystemToolAhriDataHandler = createHandlerChainRunner(chain,"AHRIData");
export default AHRISystemToolAhriDataHandler;